import * as Sentry from '@sentry/vue'

export const detectSafari = () => {
  try {
    // FIXME: Consider removing this as there should be any reason
    // why we need a specific class for safari.
    // This was added by Loi to fix an issue with safari but we lost track of the original issue.
    // @huongnguyen2152 15.05.2020
    // eslint-disable-next-line
    let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    const ua = window.navigator.userAgent
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
    const webkit = !!ua.match(/WebKit/i)
    const iOSSafari = iOS && webkit && !ua.match(/CriOS/i)
    if (isSafari || iOSSafari) {
      document.body.classList.add('safari-browser')
    }
  } catch (error) {
    Sentry.captureException(error)
  }
}
